import { GetServerSideProps } from "next";
import createExternalRedirect from "../components/redirect/ExternalRedirect";
import createServerContext from "../context/server-context";

/**
 * This page is used to force NextJS page routing
 * see `next.config.js` for details
 */
const EmptyPage = createExternalRedirect(
  "https://static.iohk.io/terms/iog-privacy-policy.pdf"
);

export default EmptyPage;

export const getServerSideProps: GetServerSideProps = async (baseCtx) => {
  const ctx = createServerContext(baseCtx);
  ctx.logger.debug("This should never happen, i.e. redirect happens before");
  return { props: {} };
};
